module.exports = __webpack_public_path__ + "static/media/efecte-itsm.d7e3da51.png";